import React from 'react';
import { Button, TrevorIcon } from '@trevor/ui-components';
import { useGetSavedQueryCacheStatusQuery } from '@/features/query-builder/savedQueriesApiSlice';
import { useDatasourceId, useSeriesId } from '@/hooks';
import { useRefreshQuery } from '@/views/QueryBuilder/hooks/useRefreshQuery';
import {
  CachedInfoBanner,
  CachedInfoContainer,
} from '@/views/QueryBuilder/subcomponents/CachedInfo/CachedInfo.styles';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';

dayjs.extend(relativeTime);

const MIN_SECONDS_FOR_BANNER = 45;

export const CachedInfo = () => {
  const datasourceId = useDatasourceId();
  const seriesId = useSeriesId();
  const refresh = useRefreshQuery();

  const { data, isFetching } = useGetSavedQueryCacheStatusQuery(
    {
      datasourceId,
      seriesId,
    },
    {
      skip: !seriesId,
    },
  );

  if (isFetching || !data?._cached_time || !seriesId) {
    return null;
  }

  const currentTime = dayjs();
  const cachedTime = dayjs(data._cached_time);
  const diffSeconds = currentTime.diff(cachedTime, 'second');

  return (
    <CachedInfoContainer>
      {diffSeconds >= MIN_SECONDS_FOR_BANNER && (
        <CachedInfoBanner severity="warning">
          Your results were last refreshed {dayjs(data._cached_time).fromNow()}.
          To see latest results, click refresh.
          <Button
            variant="secondary"
            icon={<TrevorIcon name="refresh" />}
            onClick={refresh}
          />
        </CachedInfoBanner>
      )}
    </CachedInfoContainer>
  );
};
